import React, { useState } from "react";
import Logo from "../../assets/images/1.png";
import InspectionLogo from "../../assets/images/InspectionLogo.png";
import Profile from "../../assets/images/profile-img.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faList, faEyeSlash, faEye  } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { Link } from "react-router-dom";
import "./AdminSideBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import $ from 'jquery'; 

const AdminHeader = () => {
  // function capitalFirstLetter(string) {
  //     return string.charAt(0).toUpperCase() + string.slice(1);
  // }

  const navigate = useNavigate()

  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);
  const [passwordShown3, setPasswordShown3] = useState(false);

  function mySidebarToggle() {
    var element = document.getElementById("myDIV");
    element.classList.toggle("mystyle");
    var element2 = document.getElementById("main");
    element2.classList.toggle("fullDiv");
  }

  function handleChangePassword() {

    if(newPassword !== confirmNewPassword) {
      alert("New Password and Confirm Password does not match");
      return;
    }

    if(window.location.href.includes("inspection")) {
      axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/inspectionUsers/inschangePassword`,
        {
          modifiedByUC:  sessionStorage.getItem("userCode"),  
          userId: sessionStorage.getItem("userId"),
          password: oldPassword,
          passwordNew: newPassword,
          passwordConfirm: confirmNewPassword
        }
      )
      .then(function (response) { 
        alert(response.data.message);
        if(response.data.success) {
          // $("#modal").modal('hide');
          $('#changeBtn').on('click', function () {
            $('#changePasswordModel').modal('hide');        
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
          navigate("/login");
        }   
      })
      .catch(function (error) {
        console.log(error);
      });

    }else {

    

    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/users/changePassword`,
        {
          userCode: localStorage.getItem("userCodeGlobal"),
          password: oldPassword,
          passwordNew: newPassword,
          passwordConfirm: confirmNewPassword,
          modifiedByUC: localStorage.getItem("userCodeGlobal"),
        }
      )
      .then(function (response) { 
        alert(response.data.message);
        if(response.data.success) {
          // $("#modal").modal('hide');
          $('#changeBtn').on('click', function () {
            $('#changePasswordModel').modal('hide');        
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
          navigate("/login");
        }   
      })
      .catch(function (error) {
        console.log(error);
      });}
  }

function handleResetValue() {
  setOldPassword("")
  setNewPassword("")
  setConfirmNewPassword("")
  setPasswordShown1(false)
  setPasswordShown2(false)
  setPasswordShown3(false)
}

  return (
    <>
      <div id="header" className="header fixed-top d-flex align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <i className="toggle-sidebar-btn">
            <FontAwesomeIcon icon={faBars} onClick={mySidebarToggle} />
          </i>
          {window.location.href.includes("GCES") ? (
            <h1
              style={{
                marginLeft: "64px",
                letterSpacing: "11px",
                color: "green",
              }}
            >
              GCES
            </h1>
          ) : window.location.href.includes("inspection") ? (
            <Link
              to="/inspection/dashboard"
              className="logo d-flex align-items-center innerLogo"
            >
              <img src={InspectionLogo} style={{ width: "242px" }} />
            </Link>
          ) : (
            <Link
              to="/cropic/dashboard"
              className="logo d-flex align-items-center innerLogo"
            >
              <img src={Logo} style={{ width: "180px" }} />
            </Link>
          )}
        </div>

        <div className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            <li className="nav-item dropdown pe-3">
              <a
                className="nav-link nav-profile d-flex align-items-center pe-0"
                data-bs-toggle="dropdown"
              >
                <img src={Profile} alt="Profile" className="rounded-circle" />
                {/* <span className="d-none d-md-block dropdown-toggle ps-2">{capitalFirstLetter(sessionStorage.getItem("userId"))}</span> */}
                {window.location.href.includes("inspection") ? (
                  <span className="d-none d-md-block dropdown-toggle ps-2 ">
                    {sessionStorage.getItem("userName")}
                  </span>
                ) : (
                  <span className="d-none d-md-block dropdown-toggle ps-2">
                    {localStorage.getItem("username")}
                  </span>
                )}
              </a>

              {window.location.href.includes("inspection") ? (
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile inspectionDrop">
                  <li className="dropdown-header">
                    {/* <h6>{capitalFirstLetter(sessionStorage.getItem("userId"))}</h6>   */}
                    <h6>{sessionStorage.getItem("userName")}</h6>
                  </li>
                  {/* <li>
                    <strong>User Name :</strong>{" "}
                    <span>{sessionStorage.getItem("userName")}</span>
                  </li> */}


{/* <li style={{backgroundColor : "F0F0F0"}}>
                
                    <i className="bi bi-box-arrow-right"></i>
                 
                    <span
                      type="button"
                      className="dropdown-item d-flex btn-info"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModel"
              
                      
                    >
                    
                
                    </span>
                    
                  </li> */}

                  {/* <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span
                        onClick={() => {
                          sessionStorage.removeItem("user");
                        }}
                      >
                         Change Password
                      </span>
                    </a>
                  </li> */}
                      <li > 
                    <i className="bi bi-box-arrow-right"></i>
                    <span
                      type="button"
                      // className="dropdown-item d-flex btn-info"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModel"              
                    >                  
                     Change Password
                    </span>
                  </li>

                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span
                        onClick={() => {
                          sessionStorage.removeItem("user");
                        }}
                      >
                        Sign Out---
                      </span>
                    </a>
                  </li>
                </ul>
              ) : (
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                  <li className="dropdown-header">
                    {/* <h6>{capitalFirstLetter(localStorage.getItem("username"))}</h6>   */}
                    <h6>{localStorage.getItem("username")}</h6>
                  </li>
                  <li>
                    <strong>Role :</strong>{" "}
                    <span>{sessionStorage.getItem("userRoleName")}</span>
                  </li>
                  <li>
                    <strong>Organization:</strong>{" "}
                    <span>{sessionStorage.getItem("orgTypeCodeGlobal") === "G" ? "Government" : "Insurance"}</span>
                  </li>
                  <li>
                    <strong>Designation :</strong>{" "}
                    <span>{sessionStorage.getItem("designationName")}</span>
                  </li>
                  <li style={{backgroundColor : "F0F0F0"}}>
                    {/* <a className="dropdown-item d-flex align-items-center" href="#"> */}
                    <i className="bi bi-box-arrow-right"></i>
                    {/* <span onClick={handleChangePassword}>Change Password</span> */}
                    <span
                      type="button"
                      className="dropdown-item d-flex btn-info"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModel"
                      // onClick={handleChangePassword}
                      
                    >
                     
                      <strong style={{ fontSize : "15px"}}> Change Passwosssrd</strong>
                    </span>
                    {/* </a> */}
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                      style={{backgroundColor : "F0F0F0"}}
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span 
                        onClick={() => {
                          sessionStorage.removeItem("user");
                        }}
                      >
                        <strong style={{ fontSize : "20px"}}>Logout</strong>
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </div>

      <div className="modal" id="changePasswordModel">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
             <strong> Change Password</strong>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={handleResetValue}
              >X</button>
            </div>

            <div className="modal-body">
              {/* <label for="add_season" className="form-label">
                Add New User Type
              </label> */}
              Old Password 
              <div className="input-group ">
              
              <input
               type={passwordShown1 ? "text" : "password"}
                className="form-control"
                
                // placeholder="Old Password "
                onChange={(e) => setOldPassword(e.target.value)}
                value = {oldPassword}
              />
               <i class="flex justify-around items-center showhidebtns"  onClick={() => setPasswordShown1(!passwordShown1)}>
                                      <FontAwesomeIcon icon={passwordShown1 ? faEyeSlash : faEye} />
                                    </i>{" "}
              </div>
              New Password 
              <div className="input-group">
             
               <input
                type={passwordShown2 ? "text" : "password"}
                className="form-control"
                // placeholder="New Password"
                onChange={(e) => setNewPassword(e.target.value)}
                 value={newPassword}
              />
               <i class="flex justify-around items-center showhidebtns"  onClick={() => setPasswordShown2(!passwordShown2)}>
                                      <FontAwesomeIcon icon={passwordShown2 ? faEyeSlash : faEye} />
                                    </i>{" "}
              </div>
              Confirm New Password 
      <div className="input-group">
      
               <input
                type={passwordShown3 ? "text" : "password"}
                className="form-control"
                // placeholder="Confirm New Password"
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                value={confirmNewPassword}
              />
               <i class="flex justify-around items-center showhidebtns"  onClick={() => setPasswordShown3(!passwordShown3)}>
                                      <FontAwesomeIcon icon={passwordShown3 ? faEyeSlash : faEye} />
                                    </i>{" "}

      </div>
        
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                id="changeBtn"
                //  data-bs-dismiss="modal"
                 onClick={handleChangePassword}
              >
                Change
              </button>
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={handleResetValue}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminHeader;
